<script lang="ts">
  import WorldMap from "../world-map.svelte";
</script>

<div class="page-stats-map">
  <WorldMap />
</div>
